export default {
  LOAD_MY_STUDIES_STUDENT_OVERVIEW_PAGE_START: 'LoadMyStudiesStudentOverviewPageStart',
  LOAD_MY_STUDIES_STUDENT_OVERVIEW_PAGE_END: 'LoadMyStudiesStudentOverviewPageEnd'
};